import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/menu/logo.png'
import _imports_1 from '@/assets/images/menu/tokenflip.png'
import _imports_2 from '@/assets/images/menu/blackjack.png'
import _imports_3 from '@/assets/images/menu/hideandseek.png'
import _imports_4 from '@/assets/images/menu/rps.png'
import _imports_5 from '@/assets/images/menu/1v1.png'
import _imports_6 from '@/assets/images/menu/hazelnut.png'
import _imports_7 from '@/assets/images/menu/nft.png'
import _imports_8 from '@/assets/images/menu/stake.png'
import _imports_9 from '@/assets/images/menu/referrals.png'


const _hoisted_1 = { class: "sidebar-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "ElrondBet Games Logo",
  class: "img-fluid"
}, null, -1)
const _hoisted_3 = { class: "menu-container" }
const _hoisted_4 = { class: "menu-category" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "category-title font-Baloo-Regular" }, "Game Center", -1)
const _hoisted_6 = { class: "menu-item dropdown" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "24",
    height: "24"
  })
], -1)
const _hoisted_8 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_9 = {
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    width: "20",
    height: "20"
  })
], -1)
const _hoisted_11 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_12 = {
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "20",
    height: "20"
  })
], -1)
const _hoisted_14 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_15 = {
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    width: "20",
    height: "20"
  })
], -1)
const _hoisted_17 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_18 = {
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    width: "20",
    height: "20"
  })
], -1)
const _hoisted_20 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_21 = {
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    width: "20",
    height: "20"
  })
], -1)
const _hoisted_23 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_24 = {
  class: "menu-item",
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    width: "24",
    height: "24"
  })
], -1)
const _hoisted_26 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "menu-category" }, null, -1)
const _hoisted_28 = { class: "menu-category" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "category-title font-Baloo-Regular" }, "Staking", -1)
const _hoisted_30 = {
  class: "menu-item",
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    width: "24",
    height: "24"
  })
], -1)
const _hoisted_32 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_33 = {
  class: "menu-item",
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    width: "24",
    height: "24"
  })
], -1)
const _hoisted_35 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_36 = {
  key: 0,
  class: "menu-category"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "category-title font-Baloo-Regular" }, "Account", -1)
const _hoisted_38 = {
  class: "menu-item",
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    width: "24",
    height: "24"
  })
], -1)
const _hoisted_40 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_41 = {
  key: 0,
  class: "account-wrapper"
}
const _hoisted_42 = {
  key: 1,
  class: "login-section"
}
const _hoisted_43 = /*#__PURE__*/_createStaticVNode("<div class=\"social-links\"><a href=\"https://twitter.com/token_nuts\" target=\"_blank\" class=\"social-link\"><i class=\"bi bi-twitter-x\"></i></a><a href=\"https://t.me/tokennuts\" target=\"_blank\" class=\"social-link\"><i class=\"bi bi-telegram\"></i></a><a href=\"https://discord.gg/UNKMB2TJRK\" target=\"_blank\" class=\"social-link\"><i class=\"bi bi-discord\"></i></a><a href=\"https://docs.elrondbet.net/\" target=\"_blank\" class=\"social-link\"><i class=\"bi bi-filetype-doc\"></i></a></div>", 1)
const _hoisted_44 = { class: "legal-footer" }
const _hoisted_45 = { class: "copyright-text" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "separator" }, "|", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SidebarAccount = _resolveComponent("SidebarAccount")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: { name: _ctx.ROUTES.home },
      class: "sidebar-logo d-none d-lg-flex"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", {
            class: "menu-link dropdown-toggle",
            href: "#",
            role: "button",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleGamesDropdown && _ctx.toggleGamesDropdown(...args)), ["prevent"])),
            ref: "dropdownToggleRef"
          }, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("menu.games")), 1),
            _createElementVNode("i", {
              class: _normalizeClass(['bi', 'ms-auto', 'menu-arrow', _ctx.isGamesDropdownOpen ? 'bi-chevron-up' : 'bi-chevron-down'])
            }, null, 2)
          ], 512),
          _createElementVNode("ul", {
            class: _normalizeClass(["dropdown-menu games-dropdown", { 'show': _ctx.isGamesDropdownOpen }]),
            ref: "gamesDropdownRef"
          }, [
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.ROUTES.blackjack },
                class: _normalizeClass(['dropdown-item', { active: _ctx.route.name === _ctx.ROUTES.blackjack }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isGamesDropdownOpen = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("menu.blackjack")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"])
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.ROUTES.tokenFlip },
                class: _normalizeClass(['dropdown-item', { active: _ctx.route.name === _ctx.ROUTES.tokenFlip }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isGamesDropdownOpen = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("menu.tokenFlip")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"])
            ]),
            _createElementVNode("li", _hoisted_15, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.ROUTES.hideAndSeek },
                class: _normalizeClass(['dropdown-item', { active: _ctx.route.name === _ctx.ROUTES.hideAndSeek }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isGamesDropdownOpen = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_16,
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("menu.hideAndSeek")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"])
            ]),
            _createElementVNode("li", _hoisted_18, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.ROUTES.rps },
                class: _normalizeClass(['dropdown-item', { active: _ctx.route.name === _ctx.ROUTES.rps }]),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isGamesDropdownOpen = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_19,
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("menu.rps")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"])
            ]),
            _createElementVNode("li", _hoisted_21, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.ROUTES.play1v1 },
                class: _normalizeClass(['dropdown-item', { active: _ctx.route.name === _ctx.ROUTES.play1v1 }]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isGamesDropdownOpen = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_22,
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("menu.play1v1")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"])
            ])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.ROUTES.nutsRoulette },
            class: _normalizeClass(['menu-link', { active: _ctx.route.name === _ctx.ROUTES.nutsRoulette }])
          }, {
            default: _withCtx(() => [
              _hoisted_25,
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("menu.nutsRoulette")), 1)
            ]),
            _: 1
          }, 8, ["to", "class"])
        ])
      ]),
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.ROUTES.staking.nfts },
            class: _normalizeClass(['menu-link', { active: _ctx.route.name === _ctx.ROUTES.staking.nfts }])
          }, {
            default: _withCtx(() => [
              _hoisted_31,
              _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("menu.stakingNfts")), 1)
            ]),
            _: 1
          }, 8, ["to", "class"])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.ROUTES.staking.nuts },
            class: _normalizeClass(['menu-link', { active: _ctx.route.name === _ctx.ROUTES.staking.nuts }])
          }, {
            default: _withCtx(() => [
              _hoisted_34,
              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("menu.stakingNuts")), 1)
            ]),
            _: 1
          }, 8, ["to", "class"])
        ])
      ]),
      (_ctx.address)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.ROUTES.referrals },
                class: _normalizeClass(['menu-link', { active: _ctx.route.name === _ctx.ROUTES.referrals }])
              }, {
                default: _withCtx(() => [
                  _hoisted_39,
                  _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("menu.referrals")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.address)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createVNode(_component_SidebarAccount)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("button", {
            class: "login-button font-Baloo-Regular",
            "data-bs-dismiss": "offcanvas",
            "data-bs-target": "#offcanvas",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.navigateToLogin && _ctx.navigateToLogin(...args)))
          }, _toDisplayString(_ctx.$t("menu.login")), 1)
        ])),
    _hoisted_43,
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("span", _hoisted_45, "© " + _toDisplayString(_ctx.currentYear) + " ElrondBet", 1),
      _hoisted_46,
      _createElementVNode("a", {
        href: "#",
        class: "legal-link",
        "data-bs-dismiss": "offcanvas",
        "data-bs-target": "#offcanvas",
        onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToDisclaimer && _ctx.goToDisclaimer(...args)), ["prevent"]))
      }, " Disclaimer ")
    ])
  ]))
}